import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";

let prefix = ""
const routes = [
	{path: prefix + '/text', component: () => import('@/views/text')},
	{path: prefix + '/', component: () => import('@/views/Diverter/Home')},
	{path: prefix + '/aboutUs', component: () => import('@/views/Diverter/AboutUs/AboutUs')},
	{path: prefix + '/ListHistory', component: () => import('@/views/Diverter/AboutUs/ListHistory')},
	{path: prefix + '/ListHonor', component: () => import('@/views/Diverter/AboutUs/ListHonor')},
	{path: prefix + '/Culture', component: () => import('@/views/Diverter/AboutUs/Culture')},

	{path: prefix + '/Products', component: () => import('@/views/Diverter/Products/Products')},
	{path: prefix + '/ShowProduct', component: () => import('@/views/Diverter/Products/ShowProduct')},

	{path: prefix + '/JoinUs', component: () => import('@/views/Diverter/JoinUs/JoinUs')},
	{path: prefix + '/SocialInde', component: () => import('@/views/Diverter/JoinUs/SocialInde')},
	{path: prefix + '/ContactUs', component: () => import('@/views/Diverter/JoinUs/ContactUs')},
	{path: prefix + '/Support', component: () => import('@/views/Diverter/JoinUs/Support')},
	{path: '/:catchAll(.*)', name: 'not-found', component: () => import('@/views/Diverter/404'),}

	// {path: prefix + '/ListTxt', component: () => import('@/views/ListTxt/ListTxt')},
	// {path: prefix + '/ListTxt/ShowNews', component: () => import('@/views/ListTxt/ShowNews')},
]

const router = createRouter({
	history: createWebHistory(),
	routes
})
export default router
